// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SuccessMessage } from '@interfaces/interfaces';

@Component({
    selector: 'app-success-modal',
    templateUrl: './success-modal.component.html',
    styleUrls: ['./success-modal.component.scss'],
})
export class SuccessModalComponent {
    constructor(
        private dialogRef: MatDialogRef<SuccessModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: SuccessMessage
    ) {
        if (data.autoClose) {
            setTimeout(() => {
                this.close();
            }, 3000);
        }
    }

    close() {
        this.dialogRef.close();
    }

    breakContent() {
        if (!this.data.displayFullMessage && !this.data.richContent) {
            return this.data?.content
                ? this.data.content
                      .split(' ')
                      .map((word) => (word.length > 20 ? `${word.substring(0, 20)}...` : word))
                      .join(' ')
                : '';
        } else if (!this.data?.richContent) {
            return this.data?.content || '';
        } else {
            return this.data?.richContent;
        }
    }
}
